import { useEffect, useContext } from "react";
import { useNavigate,Link } from "react-router-dom";
import { AuthContext } from '../services/authContext';

const Unauthorised = () => {
    const navigate = useNavigate();
    const { isLoggedIn } = useContext(AuthContext);
    useEffect(() => {
        if (!isLoggedIn) {
            const timer = setTimeout(() => {
                navigate("/");
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [navigate]);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100">
            <h1 className="text-center">Access Denied</h1>
            <p className="text-center">
                You do not have the required permission to access this area. If you feel this is incorrect please get in touch with your Service Lead or an Admin.
            </p>
            <p className="text-center text-muted mt-3">
                <Link to="/">Back to Dashboard</Link>
            </p>
        </div>
    );
};

export default Unauthorised;
